import { render, staticRenderFns } from "./PrevisualizeAndSendFiscalAttestation.vue?vue&type=template&id=321c271e&scoped=true&"
import script from "./PrevisualizeAndSendFiscalAttestation.vue?vue&type=script&lang=js&"
export * from "./PrevisualizeAndSendFiscalAttestation.vue?vue&type=script&lang=js&"
import style0 from "./PrevisualizeAndSendFiscalAttestation.vue?vue&type=style&index=0&id=321c271e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321c271e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321c271e')) {
      api.createRecord('321c271e', component.options)
    } else {
      api.reload('321c271e', component.options)
    }
    module.hot.accept("./PrevisualizeAndSendFiscalAttestation.vue?vue&type=template&id=321c271e&scoped=true&", function () {
      api.rerender('321c271e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrevisualizeAndSendFiscalAttestation.vue"
export default component.exports